var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "panel result" }, [
    _c(
      "div",
      { staticClass: "panel-block p-5" },
      [
        _c("b-icon", {
          attrs: {
            icon: _vm.policyIcon,
            size: "is-large",
            "custom-size": "fa-4x",
            type: _vm.policyType,
          },
        }),
        _c("span", { staticClass: "has-text-centered pt-5" }, [
          _vm._v(_vm._s(_vm.policyResultText)),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }